import React from "react";
import { Alert, Button } from 'react-bootstrap';
import Aux from '../../../hoc/Aux';

const errorResult = (props) => {
  const errors = props.errors.map((el, index) => (
    <span className="d-block" key={"err-msg-"+index}>{el}</span>
  ));

  return (
    <Aux>
      <Alert variant="danger">
      <Alert.Heading>Broneerimine ebaõnnestus!</Alert.Heading>
      <p>
        {errors}
      </p>
    </Alert>
    <Button className="mt-2" variant="primary" onClick={props.backBtnClicked}>Mine tagasi</Button>
    </Aux>
  );

}

export default errorResult;